import { jsx as C } from "react/jsx-runtime";
const r = ({
  size: H
}) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M5.5 11.8317H10.5V10.8317H5.5V11.8317ZM5.5 9.16504H10.5V8.16504H5.5V9.16504ZM4.20517 14.3317C3.86839 14.3317 3.58333 14.215 3.35 13.9817C3.11667 13.7484 3 13.4633 3 13.1265V2.87021C3 2.53343 3.11667 2.24837 3.35 2.01504C3.58333 1.78171 3.86839 1.66504 4.20517 1.66504H9.5L13 5.16504V13.1265C13 13.4633 12.8833 13.7484 12.65 13.9817C12.4167 14.215 12.1316 14.3317 11.7948 14.3317H4.20517ZM9 5.66504V2.66504H4.20517C4.15383 2.66504 4.10683 2.68643 4.06417 2.72921C4.02139 2.77187 4 2.81887 4 2.87021V13.1265C4 13.1779 4.02139 13.2249 4.06417 13.2675C4.10683 13.3103 4.15383 13.3317 4.20517 13.3317H11.7948C11.8462 13.3317 11.8932 13.3103 11.9358 13.2675C11.9786 13.2249 12 13.1779 12 13.1265V5.66504H9Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M8.25 17.75H15.75V16.25H8.25V17.75ZM8.25 13.75H15.75V12.25H8.25V13.75ZM6.30775 21.5C5.80258 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30775C4.5 3.80258 4.675 3.375 5.025 3.025C5.375 2.675 5.80258 2.5 6.30775 2.5H14.25L19.5 7.75V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6923 21.5H6.30775ZM13.5 8.5V4H6.30775C6.23075 4 6.16025 4.03208 6.09625 4.09625C6.03208 4.16025 6 4.23075 6 4.30775V19.6923C6 19.7693 6.03208 19.8398 6.09625 19.9038C6.16025 19.9679 6.23075 20 6.30775 20H17.6923C17.7692 20 17.8398 19.9679 17.9038 19.9038C17.9679 19.8398 18 19.7693 18 19.6923V8.5H13.5Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M6.875 14.7933H13.125V13.5433H6.875V14.7933ZM6.875 11.46H13.125V10.21H6.875V11.46ZM5.25646 17.9183C4.83549 17.9183 4.47917 17.7725 4.1875 17.4808C3.89583 17.1891 3.75 16.8328 3.75 16.4118V3.59142C3.75 3.17045 3.89583 2.81413 4.1875 2.52246C4.47917 2.23079 4.83549 2.08496 5.25646 2.08496H11.875L16.25 6.45996V16.4118C16.25 16.8328 16.1042 17.1891 15.8125 17.4808C15.5208 17.7725 15.1645 17.9183 14.7435 17.9183H5.25646ZM11.25 7.08496V3.33496H5.25646C5.19229 3.33496 5.13354 3.3617 5.08021 3.41517C5.02674 3.4685 5 3.52725 5 3.59142V16.4118C5 16.476 5.02674 16.5348 5.08021 16.5881C5.13354 16.6416 5.19229 16.6683 5.25646 16.6683H14.7435C14.8077 16.6683 14.8665 16.6416 14.9198 16.5881C14.9733 16.5348 15 16.476 15 16.4118V7.08496H11.25Z",
          fill: "currentColor"
        }
      );
  }
}, t = ({
  size: H
}) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M5.33217 12.0141H10.6655V10.621H5.33217V12.0141ZM5.33217 9.34745H10.6655V7.95428H5.33217V9.34745ZM4.04667 14.8043C3.62689 14.8043 3.26917 14.6565 2.9735 14.3608C2.67783 14.0651 2.53 13.7074 2.53 13.2876V2.71662C2.53 2.29684 2.67783 1.93912 2.9735 1.64345C3.26917 1.34778 3.62689 1.19995 4.04667 1.19995H9.388L13.4677 5.27962V13.2876C13.4677 13.7074 13.3198 14.0651 13.0242 14.3608C12.7285 14.6565 12.3708 14.8043 11.951 14.8043H4.04667ZM8.61767 6.04995V2.71662H4.04667V13.2876H11.951V6.04995H8.61767Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M7.99801 18.0162H15.998V15.9264H7.99801V18.0162ZM7.99801 14.0162H15.998V11.9264H7.99801V14.0162ZM6.06976 22.2014C5.44009 22.2014 4.90351 21.9797 4.46001 21.5362C4.01651 21.0927 3.79476 20.5561 3.79476 19.9264V4.06992C3.79476 3.44026 4.01651 2.90367 4.46001 2.46017C4.90351 2.01667 5.44009 1.79492 6.06976 1.79492H14.0818L20.2013 7.91442V19.9264C20.2013 20.5561 19.9795 21.0927 19.536 21.5362C19.0925 21.9797 18.5559 22.2014 17.9263 22.2014H6.06976ZM12.9263 9.06992V4.06992H6.06976V19.9264H17.9263V9.06992H12.9263Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M6.66537 15.0128H13.332V13.2714H6.66537V15.0128ZM6.66537 11.6795H13.332V9.93803H6.66537V11.6795ZM5.0585 18.5005C4.53378 18.5005 4.08662 18.3157 3.71704 17.9462C3.34746 17.5766 3.16267 17.1294 3.16267 16.6047V3.39095C3.16267 2.86623 3.34746 2.41908 3.71704 2.04949C4.08662 1.67991 4.53378 1.49512 5.0585 1.49512H11.7352L16.8347 6.5947V16.6047C16.8347 17.1294 16.65 17.5766 16.2804 17.9462C15.9108 18.3157 15.4636 18.5005 14.9389 18.5005H5.0585ZM10.7722 7.55762V3.39095H5.0585V16.6047H14.9389V7.55762H10.7722Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: H = "md",
  weight: V = "default"
}) => {
  switch (V) {
    case "bold":
      return /* @__PURE__ */ C(t, { size: H });
    case "book":
    case "default":
      return /* @__PURE__ */ C(r, { size: H });
  }
};
export {
  o as default
};
//# sourceMappingURL=DIconDocument.js.map
